if (!customElements.get('product-testimonial-panel')) {
  customElements.define(
    'product-testimonial-panel',
    class ProductTestimonialPanel extends HTMLElement {
      connectedCallback() {
        if (this.initialized) {
          this.start();
          return;
        }

        this.initialized = true;
        this.viewport = this.querySelector('.product-testimonial-panel__viewport');
        this.track = this.querySelector('[data-testimonial-track]');
        this.slides = Array.from(this.querySelectorAll('[data-testimonial-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-testimonial-dot]'));
        this.previousButton = this.querySelector('[data-testimonial-prev]');
        this.nextButton = this.querySelector('[data-testimonial-next]');
        this.interval = Number(this.dataset.interval) || 4500;
        this.transitionDuration = 520;
        this.activeIndex = this.slides.findIndex((slide) => slide.classList.contains('is-active'));

        if (this.activeIndex < 0) this.activeIndex = 0;
        if (!this.track || this.slides.length < 2) return;

        this.realSlideCount = this.slides.length;
        const firstSlideClone = this.slides[0].cloneNode(true);
        firstSlideClone.classList.remove('is-active');
        firstSlideClone.setAttribute('aria-hidden', 'true');
        this.track.appendChild(firstSlideClone);
        this.slides = Array.from(this.querySelectorAll('[data-testimonial-slide]'));
        this.setSlideWidths();
        this.showSlide(this.activeIndex, true);

        this.dots.forEach((dot, index) => {
          dot.addEventListener('click', () => {
            this.showSlide(index, true);
            this.restart();
          });
        });

        this.previousButton?.addEventListener('click', () => {
          this.previous();
          this.restart();
        });

        this.nextButton?.addEventListener('click', () => {
          this.advance();
          this.restart();
        });

        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());
        this.onResize = () => {
          this.setSlideWidths();
          this.showSlide(this.activeIndex, true);
        };
        window.addEventListener('resize', this.onResize);

        this.start();
      }

      disconnectedCallback() {
        this.stop();
        if (this.onResize) window.removeEventListener('resize', this.onResize);
      }

      start() {
        this.stop();
        this.timer = window.setInterval(() => {
          this.advance();
        }, this.interval);
      }

      stop() {
        if (this.timer) window.clearInterval(this.timer);
        if (this.resetTimer) window.clearTimeout(this.resetTimer);
      }

      restart() {
        this.start();
      }

      previous() {
        const previousIndex = (this.activeIndex - 1 + this.realSlideCount) % this.realSlideCount;
        this.showSlide(previousIndex);
      }

      setSlideWidths() {
        const slideWidth = this.viewport ? this.viewport.clientWidth : this.getBoundingClientRect().width;

        this.slides.forEach((slide) => {
          slide.style.flexBasis = `${slideWidth}px`;
          slide.style.width = `${slideWidth}px`;
        });
      }

      advance() {
        this.showSlide(this.activeIndex + 1);

        if (this.activeIndex === this.realSlideCount) {
          this.resetTimer = window.setTimeout(() => {
            this.showSlide(0, true);
          }, this.transitionDuration);
        }
      }

      showSlide(index, instant = false) {
        this.activeIndex = index;

        if (this.track) {
          if (instant) this.track.style.transition = 'none';
          const slideWidth = this.viewport ? this.viewport.clientWidth : this.getBoundingClientRect().width;
          this.track.style.transform = `translateX(-${index * slideWidth}px)`;
          if (instant) {
            this.track.offsetHeight;
            this.track.style.transition = '';
          }
        }

        this.slides.forEach((slide, slideIndex) => {
          const isActive = slideIndex === index;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });

        const activeDotIndex = index % this.realSlideCount;

        this.dots.forEach((dot, dotIndex) => {
          const isActive = dotIndex === activeDotIndex;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
      }
    }
  );
}
